/* ==========================================================================
   Poppy's Storefront V3 — collection card selector drawer
   Choose configuration -> see real price / image / what's included -> add to
   cart, without bouncing through a PDP.

   Add to cart deliberately uses the drawer's native <form> POST to
   routes.cart_add_url, which is the same path the existing PDP v2 form uses.
   That keeps UpCart and checkout behaviour byte-for-byte unchanged. Switching
   this to AJAX requires UpCart integration work that is not authorised yet.
   ========================================================================== */
(function () {
	'use strict';

	var OPEN_CLASS = 'is-open';
	var BODY_CLASS = 'v3-drawer-open';
	var lastFocused = null;

	function drawerFor(id) {
		return document.getElementById(id);
	}

	function openDrawer(drawer, trigger) {
		if (!drawer) return;
		lastFocused = trigger || null;
		drawer.classList.add(OPEN_CLASS);
		drawer.removeAttribute('aria-hidden');
		document.body.classList.add(BODY_CLASS);

		var focusTarget = drawer.querySelector('.v3-drawer__close');
		if (focusTarget) {
			// Wait for the transition to start so iOS does not scroll the page.
			window.requestAnimationFrame(function () {
				focusTarget.focus();
			});
		}
	}

	function closeDrawer(drawer) {
		if (!drawer) return;
		drawer.classList.remove(OPEN_CLASS);
		drawer.setAttribute('aria-hidden', 'true');

		if (!document.querySelector('.v3-drawer.' + OPEN_CLASS)) {
			document.body.classList.remove(BODY_CLASS);
		}

		if (lastFocused && typeof lastFocused.focus === 'function') {
			lastFocused.focus();
			lastFocused = null;
		}
	}

	function closeAll() {
		var open = document.querySelectorAll('.v3-drawer.' + OPEN_CLASS);
		for (var i = 0; i < open.length; i++) closeDrawer(open[i]);
	}

	/* Reflect the chosen variant in the drawer: radio state, hero image,
	   and the submit button's price. All values come from the rendered
	   option node, which Liquid built from real variant data. */
	function selectOption(drawer, option) {
		if (!option || option.getAttribute('data-available') !== 'true') return;

		var options = drawer.querySelectorAll('.v3-opt');
		for (var i = 0; i < options.length; i++) {
			options[i].classList.remove('is-selected');
		}
		option.classList.add('is-selected');

		var input = option.querySelector('.v3-opt__input');
		if (input) input.checked = true;

		var variantInput = drawer.querySelector('[data-v3-variant-input]');
		if (variantInput) variantInput.value = option.getAttribute('data-variant-id');

		var priceLabel = drawer.querySelector('[data-v3-submit-price]');
		if (priceLabel) priceLabel.textContent = option.getAttribute('data-price-formatted') || '';

		var submit = drawer.querySelector('[data-v3-submit]');
		if (submit) submit.disabled = false;

		var image = option.getAttribute('data-variant-image');
		var thumb = drawer.querySelector('[data-v3-thumb-image]');
		if (image && thumb) thumb.setAttribute('src', image);

		var error = drawer.querySelector('[data-v3-error]');
		if (error) error.classList.remove('is-visible');
	}

	document.addEventListener('click', function (event) {
		var target = event.target;
		if (!target || !target.closest) return;

		/* Open */
		var trigger = target.closest('[data-v3-drawer-open]');
		if (trigger) {
			var drawer = drawerFor(trigger.getAttribute('data-v3-drawer-open'));
			if (drawer) {
				event.preventDefault();
				openDrawer(drawer, trigger);
			}
			return;
		}

		/* Close (button or overlay) */
		if (target.closest('[data-v3-drawer-close]')) {
			event.preventDefault();
			closeDrawer(target.closest('.v3-drawer'));
			return;
		}

		/* What's included */
		var toggle = target.closest('[data-v3-includes-toggle]');
		if (toggle) {
			event.preventDefault();
			var list = document.getElementById(toggle.getAttribute('aria-controls'));
			if (list) {
				var isOpen = list.classList.toggle('is-open');
				toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			}
			return;
		}

		/* Choose a configuration */
		var option = target.closest('.v3-opt');
		if (option) {
			var parentDrawer = option.closest('.v3-drawer');
			if (parentDrawer) selectOption(parentDrawer, option);
		}
	});

	/* Keyboard: Esc closes, Space/Enter picks an option */
	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape' || event.key === 'Esc') {
			closeAll();
			return;
		}

		if (event.key !== 'Enter' && event.key !== ' ') return;

		var option = event.target && event.target.closest ? event.target.closest('.v3-opt') : null;
		if (!option) return;

		event.preventDefault();
		var drawer = option.closest('.v3-drawer');
		if (drawer) selectOption(drawer, option);
	});

	/* Guard against submitting with nothing chosen, and give the shopper
	   feedback while the native POST navigates. */
	document.addEventListener('submit', function (event) {
		var form = event.target;
		if (!form || !form.matches || !form.matches('[data-v3-form]')) return;

		var variantInput = form.querySelector('[data-v3-variant-input]');
		if (!variantInput || !variantInput.value) {
			event.preventDefault();
			var error = form.querySelector('[data-v3-error]');
			if (error) {
				error.textContent = 'Choose an option first.';
				error.classList.add('is-visible');
			}
			return;
		}

		var submit = form.querySelector('[data-v3-submit]');
		if (submit) submit.classList.add('is-busy');
	});
})();

/* ==========================================================================
   "Shop by" chips — active state for the product-type fallback

   The chips are plain server-rendered links and work with JavaScript off.
   This only adds the highlight for the currently-selected chip.

   It is needed for the product_type fallback tier because Liquid cannot read
   query parameters, so the server has no way to know which chip is active.
   When the chips are driven by a real Shopify facet (see
   snippets/v3-collection-nav.liquid) the active state comes from
   `value.active` in Liquid instead and this code does nothing, because the
   [data-v3-shopby-types] hook is absent.
   ========================================================================== */
(function () {
	'use strict';

	var nav = document.querySelector('[data-v3-shopby-types]');
	if (!nav) return;

	var ACTIVE = 'is-active';
	var params = new URLSearchParams(window.location.search);
	// getAll: a shopper can legitimately have more than one type selected.
	var selected = params.getAll('filter.p.product_type');

	if (!selected.length) {
		var all = nav.querySelector('[data-v3-chip-all]');
		if (all) all.classList.add(ACTIVE);
		return;
	}

	Array.prototype.forEach.call(nav.querySelectorAll('[data-v3-chip-value]'), function (chip) {
		var value = chip.getAttribute('data-v3-chip-value');
		if (selected.indexOf(value) === -1) return;

		chip.classList.add(ACTIVE);
		chip.setAttribute('aria-current', 'true');
		// Tapping an active chip clears it, matching how Shopify's own facets
		// behave, so a shopper is never stuck inside one family.
		chip.setAttribute('href', chip.getAttribute('href').split('?')[0]);
	});
}());

/* ==========================================================================
   "About this collection" — expanded by default on desktop only

   <details> cannot be opened by CSS and Liquid cannot know the viewport, so
   the default state is set here. Mobile stays collapsed: that is the whole
   point of moving the copy below the grid. Desktop has the room, and leaving
   it open means the text is visible without a click.

   Runs once on load and deliberately does NOT listen for resize — if the
   shopper has opened or closed the panel themselves, a later resize must not
   override that choice.
   ========================================================================== */
(function () {
	'use strict';

	var about = document.querySelector('[data-v3-about]');
	if (!about) return;

	if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
		about.setAttribute('open', '');
	}
}());

/* ==========================================================================
   Kit helper inside the card drawer

   This deliberately contains NO recommendation logic. The advice, the tiles and
   the copy all come from the coverage_calculator metaobject via
   snippets/pdp-v2-coverage-calculator.liquid — the same snippet and the same
   data the product page uses. This file only opens the panel, swaps in the copy
   for the tile that was tapped, and turns kit names that the copy already
   mentions into shortcuts. Changing what is recommended means editing the
   metaobject in Shopify, not editing this file.

   Everything is scoped to the drawer that was interacted with. A collection
   page renders one drawer per product, so document-wide lookups — which is what
   the product page version does, since it only ever has one — would read
   another product's coverage copy.
   ========================================================================== */
(function () {
	'use strict';

	function coverageDataFor(scope) {
		var el = scope.querySelector('[data-coverage-data]');
		if (!el) return null;
		try {
			return JSON.parse(el.textContent);
		} catch (e) {
			return null;
		}
	}

	/* The metaobject copy names kits in prose ("a Basic Kit or Complete Kit"),
	   so there is no single machine-readable recommendation to apply. Rather
	   than inventing a rule to pick one — which would be a second, invisible
	   recommendation system that could disagree with the copy — every kit name
	   the copy mentions becomes tappable and selects that option.

	   Matching is exact against the variant titles Liquid already rendered, so
	   nothing is guessed. Names with no matching option (a refill size that
	   lives on a different product, for example) stay as plain text.

	   Longest title first: otherwise "Complete Kit" would match inside
	   "Complete Double Coverage Kit" and link to the wrong option. */
	function linkKitNames(html, drawer) {
		var titles = [];
		Array.prototype.forEach.call(drawer.querySelectorAll('.v3-opt'), function (opt) {
			var nameEl = opt.querySelector('.v3-opt__name');
			if (!nameEl || opt.getAttribute('data-available') !== 'true') return;
			// textContent picks up the badge too; the first text node is the title.
			var title = (nameEl.childNodes[0] && nameEl.childNodes[0].nodeValue || '').trim();
			if (title) titles.push({ title: title, id: opt.getAttribute('data-variant-id') });
		});

		titles.sort(function (a, b) { return b.title.length - a.title.length; });

		// Placeholder pass so an earlier replacement cannot be re-matched by a
		// later, shorter title.
		var slots = [];
		titles.forEach(function (t) {
			var safe = t.title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			html = html.replace(new RegExp('(?![^<]*>)' + safe, 'g'), function (match) {
				slots.push(
					'<button type="button" class="v3-opt-help__pick" data-v3-kit-pick="' +
					t.id + '">' + match + '</button>'
				);
				return '\u0000' + (slots.length - 1) + '\u0000';
			});
		});

		return html.replace(/\u0000(\d+)\u0000/g, function (m, i) { return slots[+i]; });
	}

	document.addEventListener('click', function (event) {
		var target = event.target;
		if (!target || !target.closest) return;
		if (!target.closest('.v3-drawer')) return;

		/* Open / close the helper */
		var toggle = target.closest('[data-v3-kit-help-toggle]');
		if (toggle) {
			event.preventDefault();
			var wrap = toggle.closest('[data-v3-kit-help]');
			var open = wrap.classList.toggle('is-open');
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			return;
		}

		/* Jump straight to the kit the copy named */
		var pick = target.closest('[data-v3-kit-pick]');
		if (pick) {
			event.preventDefault();
			var d = pick.closest('.v3-drawer');
			var wanted = d.querySelector('.v3-opt[data-variant-id="' + pick.getAttribute('data-v3-kit-pick') + '"]');
			if (wanted) {
				// Reuse the drawer's own selection path so radio state, hidden
				// variant input, header thumbnail and Add to Cart price all stay
				// in sync exactly as they do on a manual tap.
				wanted.click();
				wanted.scrollIntoView({ block: 'nearest' });
			}
			return;
		}

		/* Coverage tile -> show that answer's copy */
		var tile = target.closest('.pdp-v2__coverage-tile');
		if (!tile) return;
		event.preventDefault();

		var drawer = tile.closest('.v3-drawer');
		var data = coverageDataFor(drawer);
		if (!data) return;

		var recBox = drawer.querySelector('[data-coverage-rec]');
		var recText = drawer.querySelector('[data-coverage-rec-text]');
		var wasActive = tile.classList.contains('is-active');

		Array.prototype.forEach.call(drawer.querySelectorAll('.pdp-v2__coverage-tile'), function (t) {
			t.classList.remove('is-active');
		});

		if (wasActive) {
			if (recBox) recBox.classList.remove('is-open');
			return;
		}

		tile.classList.add('is-active');
		var copy = data[tile.getAttribute('data-coverage')];
		if (copy && recBox && recText) {
			recText.innerHTML = linkKitNames(copy, drawer);
			recBox.classList.add('is-open');
		}
	});
}());
